import { render, staticRenderFns } from "./editIndependent.vue?vue&type=template&id=aa544b80&scoped=true"
import script from "./editIndependent.vue?vue&type=script&lang=js"
export * from "./editIndependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa544b80",
  null
  
)

export default component.exports